import {
  CHANGE_CLIENT_PROFILE_ENTRY_STATUS,
} from '../../types';

import createAsyncActions from '../../../../utilities/createAsyncActions';

export const {
  changeClientProfileEntryStatus,
  changeClientProfileEntryStatusPending,
  changeClientProfileEntryStatusFulfilled,
  changeClientProfileEntryStatusRejected,
} = createAsyncActions(CHANGE_CLIENT_PROFILE_ENTRY_STATUS, 'changeClientProfileEntryStatus');


// WEBPACK FOOTER //
// ./src/features/client-profile/actions/postActions/changeClientProfileEntryStatusActions.js